"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 45 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M19.6326 13.7444H16.1211L18.315 0.265625H21.8265L19.6326 13.7444Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M13.1705 0.265625L9.82515 9.5398L9.42989 7.5406L8.24986 1.48003C8.24986 1.48003 8.10665 0.265625 6.58291 0.265625H1.04934L0.986328 0.494755C0.986328 0.494755 2.67619 0.844184 4.65819 2.03568L7.70567 13.7501H11.3603L16.9455 0.27135H13.1705V0.265625Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M40.7762 13.7444H44.0013L41.1887 0.265625H38.3646C37.0643 0.265625 36.7435 1.26808 36.7435 1.26808L31.5078 13.7444H35.1682L35.9014 11.7395H40.3638L40.7762 13.7444ZM36.9154 8.97841L38.7599 3.93175L39.7967 8.97841H36.9154Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M31.7871 3.50822L32.2854 0.615408C32.2854 0.615408 30.7388 0.0253906 29.1291 0.0253906C27.3877 0.0253906 23.2519 0.787255 23.2519 4.48776C23.2519 7.97058 28.1095 8.01641 28.1095 9.84375C28.1095 11.6711 23.756 11.3446 22.3182 10.1932L21.7969 13.2177C21.7969 13.2177 23.3664 13.9796 25.7609 13.9796C28.1553 13.9796 31.7699 12.7366 31.7699 9.36257C31.7699 5.85683 26.8722 5.53032 26.8722 4.00658C26.8665 2.48284 30.2863 2.67761 31.7871 3.50822Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.42403 7.54061L8.24399 1.48003C8.24399 1.48003 8.10079 0.265625 6.57705 0.265625H1.04348L0.980469 0.494755C0.980469 0.494755 3.63841 1.04468 6.18752 3.11261C8.63352 5.08315 9.42403 7.54061 9.42403 7.54061Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;